<script>
    import { onMount } from 'svelte';
    import ProductStepper from './ProductStepper.svelte';

    let product = {};

	let attributes = [];
    let variants;
    let offeredPrice;
    let mrp;
    let subtotal;

    let selected;

    let isSelected = [];
    let selectedAttributes = [];

    let quantity;
    let isAvailable = true;
    let stock;



    onMount(async () => {
        await fetch(`http://localhost:8081/product`)
        .then(r => r.json())
        .then(data => {
            product = data;
			attributes = product.attributes;
			variants = product.variants;
            selected = variants[0];
            stock = selected.stock;
            quantity = 1;
            setSelected();
            setSelectedAttributes();
            productAvailability();
        });
    })
    
    

$:  if( isAvailable ) {
        product.quantity = quantity;
        offeredPrice = selected.offeredPrice;
        mrp = selected.mrp;
        subtotal = quantity * offeredPrice;
    }
    else {
        quantity = 0;
        product.quantity = 0;
        offeredPrice = 0;
        mrp = 0;
        subtotal = 0;
    }



    function productAvailability() {
            product.quantity = quantity;
            offeredPrice = selected.offeredPrice;
            mrp = selected.mrp;
            subtotal = quantity * offeredPrice;
    }
    


    function setSelected() {
        for ( let attribute of attributes ) {
            isSelected[attribute] = selected[attribute];
        }
    }
    


    function resetQuantity() {
        quantity = 1;
    }



    function setSelectedAttributes() {
        for ( let attribute of attributes ) {
            selectedAttributes[attribute] = selected[attribute];
        }
    }



    function selectVariant (paraVariant, paraAttribute) {
        
        resetQuantity();

        selectedAttributes[paraAttribute] = paraVariant[paraAttribute];

        let variantExist = true;

        for( let variant in variants ) { 
             for( let attribute of attributes ) {
                if ( variantExist && selectedAttributes[attribute] === paraVariant[attribute] ) {
                    variantExist = true;
                }
                else{
                    variantExist = false;
                }       
            }

            if ( variantExist ) {
                isAvailable = true;
                selected = paraVariant;
                break;
            }
            else{
                isAvailable = false;
                offeredPrice = "Unavailable";
                mrp = "";
            }
        }        
    }

    
    
</script>

<style>

    .product-page {
        position: fixed;
        transform: scale(0, 0);
        visibility: hidden;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #FFFFFF;
        box-sizing: border-box;
        z-index: 5;
        opacity: 0;
        transition: all 0.2s;
        overflow-y: scroll;
    }

    .product-page:target {
        display: block;
        visibility: visible;
        transform: scale(1, 1);
        opacity: 1;
        transition: all 0.2s;
    }



    .product__gallery {
        width: 100%;
        border-bottom: 1px solid #EEEEEE;
        text-align: center;
    }

    .product__gallery img {
        height: 40vh;
    }



    .product__description {
        padding: 1rem 0;
    }
    .product__name{
        margin-bottom: 0.5rem;
        /* font-size: 1.2rem; */
        /* font-weight: 500; */
    }



    .product__variants{
        margin: 2rem 0;
    }
    .product__attribute{
        text-transform: capitalize;
    }
    .product__attribute-variant{
        margin-left: 0.5rem;
    }



    .product__unit-price>span {
        vertical-align: middle;
    }
    .product__offered-price {
        margin-left: 1rem;
        font-size: 1.5rem;
        font-weight: 600;
    }
    .product__retail-price {
        margin-left: 1rem;
        color: #999999;
        text-decoration: line-through;
    }



    .product__quantity {
        /* padding-bottom: 1.5rem; */
        border-bottom: 1px solid #EEEEEE;
    }
    .product__quantity-input {
        margin-top: 1.5rem;
    }



    .cta {
        position: relative;
        margin: 1.5rem 0;
        text-transform: none;
    }
    .price-in-cta {
        position: absolute;
        right: 1.5rem;
    }
    .is-selected {
        background-color: #FFFF00;
        border-color: #333333;
    }

</style>

<section id='product-page' class='product-page'>

    <a class="button back" href="#back">Back</a>

    <div>
        <div class='product__gallery'>
            <img src='../images/products/kashmiri-apple.webp' alt='{product.alt}'/>
        </div>

        <article class='product__description'>
            <h1 class='product__name'>{product.name}</h1>
            <div class='product__regional-name'>{product.regionalName}</div>


            {#each attributes as attribute}
                <div>
                    <div class='product__variants'>
                        <span  class='product__attribute'>{attribute}</span>
                        {#each variants as variant, index}
                            <button href='#'
                                class='button product__attribute-variant'
                                class:is-selected="{ isSelected[attribute] === variant[attribute]}"
                                on:click={ ()=> isSelected[attribute] = variant[attribute] }
                                on:click={()=>selectVariant(variant, attribute)}
                                >
                                { variant[attribute] }
                            </button>
                        {/each}
                    </div>
                </div>
            {/each}

            {#if stock === 'available'}
                <div class='product__unit-price'>
                    {#if isAvailable}
                        <span>Price</span>
                        <span class='product__retail-price'>₹{selected.mrp}</span>
                        <span class='product__offered-price'>₹{selected.offeredPrice}</span>
                    {:else}
                        <span class='product__offered-price'>Product unavailable</span>
                    {/if}
                </div>
            {/if}



            <div class='product__quantity'>
                <div class='product__quantity-input'>
                    <ProductStepper bind:quantity/>
                </div>
                <button class="button cta">
                    <span>Add {quantity} to Bag</span>
                    <span class="price-in-cta">₹{subtotal}<span>
                </button>
            </div>



            <div>
                <p>
                    Apples are a popular fruit, containing antioxidants, vitamins, dietary fiber, and a range of other nutrients. Due to their varied nutrient content, they may help prevent several health conditions.
                </p>

                <p>
                    Apples come in a variety of shapes, colors, and flavors and provide a range of nutrients that can benefit many different aspects of a person’s health.
                </p>

                <p>
                    For example, they may help reduce the risk of cancer, obesity, heart disease, diabetes, and several other conditions.
                </p>

                <p>
                    In this article, learn more about the nutritional content of apples and how they may benefit a person’s health.
                </p>
            </div>
        </article>
    </div>
</section>
